define('collection/ProviderTimeCollection',['require','lib/collection/BaseCollection','model/ProviderTimelineModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var ProviderTimelineModel = require('model/ProviderTimelineModel');

    /**
     * Flexible timeline collection
     *
     * @class TimeFlexibleCollection
     */
    return BaseCollection.extend({

        model: ProviderTimelineModel,
        url: '/booking/time-flexible-multi/',

        getCombinedTimeline: function() {
            var timeline = [];

            this.each(function(model) {
                var groupedCollection = model.collection.getCollectionGroupedByHour();
                groupedCollection.each(function(hourModel) {
                    var dateStr = hourModel.get('date') + ' ' + hourModel.get('time');

                    if (!_.contains(timeline, dateStr)) {
                        timeline.push(dateStr);
                    }
                });
            });


            timeline = timeline.map(function(dateStr) {
                return Date.parseMysqlDate(dateStr);
            });

            timeline.sort();

            return timeline;
        }

    });

});

